import type { AuthorizationScope } from "./authorization-scope";
import { LICENSE_SCOPES } from "@/features/platform-license/contract";

// Material and project details come from the application context; training and
// reuse permissions are not offered. Preserve the schema and frozen attempts.
export const omittedApplicationScopeFields = new Set(["materialId", "purpose", "term", "startsAt", "endsAt", "industries", "excludedIndustries", "deliverables", "voice", "voiceScope", "digitalDouble", "digitalDoubleScope", "dedicatedTraining", "generalTraining", "reuse"]);

export function prepareApplicationScope(scope: AuthorizationScope): AuthorizationScope {
  const values = Object.fromEntries(Object.entries(scope.values).filter(([key]) => !["term", "startsAt", "endsAt"].includes(key)));
  return { ...scope, values: {
    ...values,
    industries: scope.values.industries && scope.values.industries !== "未单独约定"
      ? scope.values.industries : `电商类：${LICENSE_SCOPES.ecommerce.join("、")}；影视类：${LICENSE_SCOPES.film.join("、")}`,
    excludedIndustries: scope.values.excludedIndustries || "未单独约定",
    deliverables: scope.values.deliverables || "未单独约定",
    voice: "不含", digitalDouble: "不涉及",
    dedicatedTraining: "不允许", generalTraining: "不允许", reuse: "不允许",
  } };
}
